import { HeatingCircuit } from 'z3k-config';
export const isHeatingModeInZone = (zone, heating_mode_id, z3k_state, z3k_config) => {
    const zone_hc = z3k_state?.[zone.heating_circuit];
    const is_zone_in_mode = zone_hc?.mode_id === heating_mode_id;
    if (!z3k_config) {
        return is_zone_in_mode;
    }
    const heating_circuit = HeatingCircuit.get.one(z3k_config, (heating_circuit) => heating_circuit.id === zone.heating_circuit);
    if (!heating_circuit) {
        return false;
    }
    return HeatingCircuit.isEnabled(heating_circuit) && is_zone_in_mode;
};
